module.exports = __webpack_public_path__ + "img/秦伟卿.6472b73c.jpg";